/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 19/7/2024
 */

import React, { useRef, useState } from 'react'
import { Backdrop, Button, IconButton, Typography, OutlinedInput, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import styles from './Notification.module.css';
import { openNotificationForm } from '../../Store/Slices/notificationSlice';
import EmailEditor from 'react-email-editor';
import { useGetNotificationByIdQuery, useUpdateNotificationMutation } from '../../Store/Services/NotificationService';

const EditNotification = () => {
    const [subject, setSubject] = useState("")
    const dispatch = useDispatch();
    const notification = useSelector((state) => state.notification);
    const emailEditorRef = useRef(null);

    let notificationData

    const { data, isSuccess, isLoading } = useGetNotificationByIdQuery(notification.selectedNotification);
    if(isSuccess){
        notificationData = data?.notification;
    }

    const onLoad = () => {
        notificationData?.template && emailEditorRef.current.editor.loadDesign(JSON.parse(notificationData?.template));
    };

    const [updateNotification] = useUpdateNotificationMutation();

    const exportHtml = () => {
        emailEditorRef.current.editor.exportHtml(async(data) => {
          const { design, html } = data;

            const dataSet = {
                notiName: notificationData.notiName,
                notiId: notificationData.notiId,
                notiValue: html,
                template: JSON.stringify(design),
                subject: subject
            }
            try {
                await updateNotification(dataSet).unwrap();
                toast.success("Notification successfully updated!");
                dispatch(openNotificationForm(false));
            } catch (err) {
                console.error(err);
                toast.error("Erorr, something went wrong!");
            }

        });
    };

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography fontWeight={600} variant={"h6"}></Typography>
                <IconButton className={styles.closeButton} onClick={() => dispatch(openNotificationForm(false))} aria-label="Close"><CloseIcon /></IconButton>
            </div>
            <Typography  variant="h5" textAlign="center" fontWeight="bold">
                Edit Notification
            </Typography>

            {isLoading && (
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={isLoading}
                >
                    <CircularProgress />
                </Backdrop>
            )}

            {!isLoading && isSuccess && (
                <form>
                    <div className={styles.formItem}>
                        <label className={styles.formLabel}>Name:</label>
                        <OutlinedInput value={notificationData?.notiName} size="small" fullWidth className={styles.formText} />
                    </div>
                    <div className={styles.formItem}>
                        <label className={styles.formLabel}>Email Subject:</label>
                        <OutlinedInput defaultValue={notificationData?.subject} onChange={(e) => setSubject(e.target.value)} size="small" fullWidth className={styles.formText} />
                    </div>
                    <div className={styles.formItem}>
                        <label className={styles.formLabel}>Value:</label>
                        <div style={{
                            border: '1px solid #c4c4c4',
                            borderRadius: '4px',
                            marginTop: '5px'
                        }}>
                            <EmailEditor
                                ref={emailEditorRef}
                                onLoad={onLoad}
                                options={{
                                    version: "latest",
                                    appearance: {
                                    theme: "modern_light"
                                    }
                                }}
                            />
                        </div>
                    </div>
                    {/* Submit Button */}
                    <div style={{ marginTop: "4rem", marginBottom: '1rem', display: 'flex', justifyContent: 'center' }}>
                        <Button onClick={exportHtml} style={{width: "10rem"}} variant="contained" aria-label="Save">Save</Button>
                    </div>
                </form>
            )}
        </>
    )
}

export default EditNotification